import { HeaderCommonProps } from "@components/Header/types";
import MyAccountUserHeader from "@pages/MyAccount/components/MyAccountHeader/MyAccountUserHeader";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { cn } from "@util/helpers";

export default function MyAccountHeader({
  textClassName,
  userIconStrokeColor,
}: Pick<
  HeaderCommonProps,
  "textClassName" | "userIconStrokeColor"
>): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const displaySubscribe =
    OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER;

  return (
    <div
      className="relative flex-none"
      data-testid="my-account-header-component"
    >
      <div className={cn("relative z-10", { "lg:mr-4": displaySubscribe })}>
        <MyAccountUserHeader
          textClassName={textClassName}
          userIconStrokeColor={userIconStrokeColor}
        />
      </div>
    </div>
  );
}
